import React from "react";
import { LanguageProvider } from "./src/context/LanguageContext";
import detectAndRedirectLanguage from "./src/utils/languageRedirect";
import "./src/styles/global.css";

export const wrapRootElement = ({ element }) => {
  return <LanguageProvider>{element}</LanguageProvider>;
};

export const onClientEntry = () => {
  // Initialize Google Analytics
  if (typeof window !== 'undefined') {
    // Load Google Analytics script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17185125169';
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', 'AW-17185125169');

    // Run comprehensive language detection and redirect
    setTimeout(() => {
      detectAndRedirectLanguage();
    }, 100);
  }
};

// Track page views on route changes
export const onRouteUpdate = ({ location }) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'AW-17185125169', {
      page_path: location.pathname,
    });
  }
};